/**
 * O `wireActionable` do painel atual (app.js:60-73), agora como props.
 *
 * O painel tem dezenas de alvos que são clicáveis mas não podem ser `<button>`:
 * chave de arquivo dentro de `<code>`, chip do grafo, cabeçalho de cartão que
 * também contém botões. Lá isso era resolvido depois, varrendo o DOM a cada
 * mutação; aqui é resolvido na origem, e quem esquecer de espalhar estas props
 * entrega um alvo que só o mouse alcança.
 *
 * Espaço além de Enter porque é o que um `<button>` de verdade faz, e o
 * `preventDefault` porque senão o espaço rola a página em vez de acionar.
 */
import type { KeyboardEvent, MouseEvent } from 'react';

export interface Acionavel {
  role: 'button';
  tabIndex: 0;
  onClick: (e: MouseEvent) => void;
  onKeyDown: (e: KeyboardEvent) => void;
}

/**
 * @param ao o que o alvo faz
 * @param interno alvo dentro de outro alvo — a chave do arquivo dentro do
 *   cabeçalho que abre o cartão. Sem parar a propagação, um clique aciona os
 *   dois: abre a doc e sanfona o cartão no mesmo gesto.
 */
export function acionavel(ao: () => void, interno = false): Acionavel {
  const disparar = (e: MouseEvent | KeyboardEvent) => {
    if (interno) e.stopPropagation();
    ao();
  };
  return {
    role: 'button',
    tabIndex: 0,
    onClick: disparar,
    onKeyDown: (e: KeyboardEvent) => {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      e.preventDefault();
      disparar(e);
    },
  };
}
